/**
 *  Copyright 2023 OwlMeans
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

import { TFunction } from 'i18next'
import { ControllerFieldState } from 'react-hook-form'


export const formatError = (t: TFunction, field: string, state: ControllerFieldState) => {
  return t(
    [
      `${field}.error.${state.error?.message || state.error?.type || 'fallback'}`,
      `${field}.error.${state.error?.type || 'fallback'}`,
      state.error?.message || `${field}.error.fallback`,
      `error.${state.error?.type}`
    ],
    {
      ...(state.error?.message
        ? {
          message: t([
            `${field}.error.message.${state.error?.message}`,
            state.error?.message
          ])
        }
        : {}
      )
    }
  )
}